interface ModelDetailSectionProps {
  title: string
  /** Monospace annotation on the right of the heading row (e.g. a unit). */
  note?: string
  children: React.ReactNode
}

/** Hairline-separated section with a heading row, shared by every detail block. */
export function ModelDetailSection({ title, note, children }: ModelDetailSectionProps) {
  return (
    <section className="border-t border-[var(--color-border)] py-12">
      <div className="mb-6 flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
        <h2 className="text-sheen pb-0.5 text-2xl font-semibold tracking-[-0.03em] md:text-3xl">
          {title}
        </h2>
        {note && (
          <span className="font-mono text-caption text-[var(--color-text-tertiary)]">
            {note}
          </span>
        )}
      </div>
      {children}
    </section>
  )
}
